import { Grid, Theme, Typography, withStyles } from '@material-ui/core'
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon'
import i18n from '../../../translations/i18n'
import { MuiClasses } from '../../../types'
interface FirstLinkModalProps {
  classes: MuiClasses
  t: i18n.TFunction
}
const styles = ({ breakpoints }: Theme) => ({
  list: {
    listStyle: 'none',
    counterReset: 'item'
  },
  listItem: {
    position: 'relative' as const,
    counterIncrement: 'item',
    marginBottom: '30px',
    '&::before': {
      content: 'counter(item)',
      position: 'absolute' as const,
      left: '-50px',
      background: '#4F9B44',
      borderRadius: '100%',
      color: '#fff',
      width: '35px',
      height: '35px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: 'circularRegular'
    }
  },
  heading: {
    marginBottom: '0.5rem',
    marginTop: '1rem',
    [breakpoints.down('sm')]: {
      marginBottom: '1rem',
      marginTop: '1.5rem'
    }
  },
  dialogContainer: {
    marginTop: '76px',
    padding: '0 40px',
    [breakpoints.down('xs')]: {
      padding: '0'
    }
  }
})
const TerminationOfTenancyModal = ({ classes, t }: FirstLinkModalProps) => {
  return (
    <Grid container className={classes.dialogContainer}>
      <Grid item xs={12} className={classes.centeredText}>
        <CloseCircleOutlineIcon color='#D43838' size={'70px'} />
      </Grid>

      <Grid item xs={12}>
        <Typography
          variant='h5'
          className={`${classes.centeredText} ${classes.heading}`}
        >
          {t('instantRent.tenancyTerminationModalTitle')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' className={`${classes.centeredText}`}>
          {t('instantRent.tenancyTerminationModalContent')}
        </Typography>
      </Grid>
    </Grid>
  )
}
export default withStyles(styles)(TerminationOfTenancyModal)
